import { computed } from 'vue'

import { EventTypeEnum } from '@/gql/myomr'

type EventApplicationConfig = {
  canAcceptAttendees: boolean
  canAddAttendees: boolean
  canDenyAttendees: boolean
  canResetAttendees: boolean
  canUploadCsvSelection: boolean
  displayBottomCTAs: boolean
  displayCloseSelectionCTA: boolean
  displayState: boolean
  displayTicketNumber: boolean
  hasSortingOptions: boolean
  hasStateFilters: boolean
}

const defaultEventApplicationConfig: EventApplicationConfig = {
  // Temporarily set to false until we implement the phases model (`EventApplication` in myomr) in manage.
  canAcceptAttendees: false,
  canAddAttendees: true,
  canDenyAttendees: false,
  canResetAttendees: false,
  canUploadCsvSelection: false,
  displayBottomCTAs: true,
  displayCloseSelectionCTA: false,
  displayState: true,
  displayTicketNumber: true,
  hasSortingOptions: true,
  hasStateFilters: true,
}

const eventApplicationConfigs: { [key in EventTypeEnum]?: EventApplicationConfig } = {
  [EventTypeEnum.DigitalMasterclass]: {
    canAcceptAttendees: false,
    canAddAttendees: false,
    canDenyAttendees: false,
    canResetAttendees: false,
    canUploadCsvSelection: false,
    displayBottomCTAs: false,
    displayCloseSelectionCTA: false,
    displayState: false,
    displayTicketNumber: false,
    hasSortingOptions: false,
    hasStateFilters: false,
  },
}

const useEventApplicationConfig = (type?: EventTypeEnum | null) =>
  computed<EventApplicationConfig>(() => (type && eventApplicationConfigs[type]) || defaultEventApplicationConfig)
export default useEventApplicationConfig
